import {useContext} from "react";

import {TimezoneContext} from "../providers/TimezoneProvider";

export const useTimezone = () => {

    const {timezone, updateTimezone, timezoneStore} = useContext(TimezoneContext);
    return {timezone, updateTimezone, timezoneStore};
}
